module.exports = __webpack_public_path__ + "static/img/cont49 (1).5a6abbc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont49 (1).jpg
// module id = KcL/
// module chunks = 0